export const apiRenteon = {
	syncRenteon: async () => {
		await apiCommon<{ data: any }>('sync-renteon', { method: 'POST' })
	},

	getNeccessaryAddons: async () => {
		const data = await apiCommon<any[]>('renteon/all-additions', { method: 'GET' })
		return data as unknown as any[]
	},
}
